<template>
  <div class="caas-mobile">
    <div class="caas-header" id="header">
      <img :src="header" />
    </div>

    <div class="caas-introduce">
      <div class="in-box">
        <div class="in-icon">
          <div class="in-img">
            <img src="../assets/web/全球覆盖.svg" />
          </div>
          <div class="icon-title">{{$t('Cass.ico1')}}</div>
        </div>
        <div class="in-icon">
          <div class="in-img">
            <img src="../assets/web/结构.svg" />
          </div>
          <div class="icon-title">{{$t('Cass.ico3')}}</div>
        </div>
      </div>
      <div class="in-box">
        <div class="in-icon">
          <div class="in-img">
            <img src="../assets/web/芯片.svg" />
          </div>
          <div class="icon-title">{{$t('Cass.ico2')}}</div>
        </div>
        <div class="in-icon">
          <div class="in-img">
            <img src="../assets/web/开放 .svg" />
          </div>
          <div class="icon-title">{{$t('Cass.ico4')}}</div>
        </div>
      </div>
      <Divider />
      <p class="in-content">{{$t('Cass.intro')}}</p>
      <router-link to="/Resources">
        <div class="more">{{$t('LEARN')}}</div>
      </router-link>
    </div>

    <div class="caas-network" id="Global">
      <p class="net-title">{{$t('Cass.global.title')}}</p>
      <div class="flex-box">
        <div class="img-box">
          <p class="img-title">{{$t('Cass.tra')}}</p>
          <img src="../assets/mobile/平台1   手机.png" />
          <p class="img-content">{{$t('Cass.global.text1')}}</p>
        </div>
        <div class="img-box">
          <p class="img-title">{{$t('Cass.tea')}}</p>
          <img src="../assets/mobile/平台2   手机.png" />
          <p class="img-content">
            {{$t('Cass.global.content1')}}
            <router-link target="_blank" to="coverage">
              <span style="cursor:pointer;">{{$t('Cass.global.check')}}</span>
            </router-link>
          </p>
        </div>
      </div>
    </div>

    <div style="background:rgba(249, 249, 249, 1)">
      <div class="embed" id="Embedded">
        <p class="em-title">{{$t('Cass.em.title')}}</p>
        <Row class="flex-box">
          <Col span="9" style="font-size:10px;font-family: 'Poppins-ExtraLight';">{{$t('Cass.OS')}}</Col>
          <Col span="5" style="font-size:10px;font-family: 'Poppins-ExtraLight';">Android</Col>
          <Col span="5" style="font-size:10px;font-family: 'Poppins-ExtraLight';">Linux</Col>
          <Col span="5" style="font-size:10px;font-family: 'Poppins-ExtraLight';">RTOS...</Col>
          <!-- <Col span="2" style="font-size:12px">...</Col> -->
        </Row>
        <Row class="flex-box">
          <Col
            span="9"
            style="font-size:10px;font-family: 'Poppins-ExtraLight';"
          >{{$t('Cass.medium')}}</Col>
          <Col span="5" style="font-size:10px;font-family: 'Poppins-ExtraLight';">TEE</Col>
          <Col span="5" style="font-size:10px;font-family: 'Poppins-ExtraLight';">eUICC</Col>
          <Col span="5" style="font-size:10px;font-family: 'Poppins-ExtraLight';">iUICC...</Col>
          <!-- <Col span="4" style="font-size:12px">...</Col> -->
        </Row>
        <Row class="flex-box">
          <Col
            span="9"
            style="font-size:10px;font-family: 'Poppins-ExtraLight';"
          >{{$t('Cass.Chip')}}</Col>
          <Col span="5" style="font-size:10px;font-family: 'Poppins-ExtraLight';">Qualcomm</Col>
          <Col span="5" style="font-size:10px;font-family: 'Poppins-ExtraLight';">MediaTek</Col>
          <Col span="5" style="font-size:10px;font-family: 'Poppins-ExtraLight';">Samsung...</Col>
          <!-- <Col span="4" style="font-size:12px">...</Col> -->
        </Row>
        <div class="content-box">
          <div class="con-box">
            <p class="con-title">{{$t('Cass.tra')}}</p>
            <p class="con-content beforeLine">{{$t('Cass.em.text1')}}</p>
            <p class="con-content beforeLine">{{$t('Cass.em.text2')}}</p>
            <p class="con-content beforeLine">{{$t('Cass.em.text3')}}</p>
          </div>
          <div class="con-box">
            <p class="con-title">{{$t('Cass.tea')}}</p>
            <p class="con-content">{{$t('Cass.em.content1')}}</p>
            <p class="con-content beforeLine">{{$t('Cass.em.content2')}}</p>
            <p class="con-content beforeLine">{{$t('Cass.em.content3')}}</p>
            <p class="con-content beforeLine">{{$t('Cass.em.content4')}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="embed" id="Open">
      <p class="em-title">{{$t('Cass.open.title')}}</p>
      <div class="content-box">
        <div class="con-box">
          <img src="../assets/mobile/The traditional approach- .png" />
          <p class="con-title">{{$t('Cass.tra')}}</p>
          <p class="con-content beforeLine">{{$t('Cass.open.text1')}}</p>
          <p class="con-content beforeLine">{{$t('Cass.open.text2')}}</p>
        </div>
        <div class="con-box" style="margin-top:0.2rem;">
          <img src="../assets/mobile/With Redtea-.png" />
          <p class="con-title">{{$t('Cass.tea')}}</p>
          <p class="con-content">{{$t('Cass.open.content1')}}</p>
          <p class="con-content beforeLine">{{$t('Cass.open.content2')}}</p>
          <p class="con-content beforeLine">{{$t('Cass.open.content3')}}</p>
        </div>
      </div>
    </div>

    <div style="background:rgba(249, 249, 249, 1);">
      <div class="smart" id="Smart">
        <p class="smart-title">{{$t('Cass.smart.title')}}</p>
        <img src="../assets/mobile/场景图.png" />
        <p class="smart-content">{{$t('Cass.smart.des')}}</p>
      </div>
    </div>

    <Modal v-model="modal" class="caas-modal" footer-hide width="90" :title="$t('coverage.title')">
      <div class="modal-title-mobile">
        <Icon type="ios-disc" color="#CF2A2A" />
        &nbsp;&nbsp;{{$t('coverage.title1')}}
      </div>
      <div class="modal-content-mobile">{{$t('coverage.text1')}}</div>
      <div class="modal-title-mobile">
        <Icon type="ios-disc" color="#CF2A2A" />
        &nbsp;&nbsp;{{$t('coverage.title2')}}
      </div>
      <div class="modal-content-mobile">{{$t('coverage.text2')}}</div>
      <div class="modal-title-mobile">
        <Icon type="ios-disc" color="#CF2A2A" />
        &nbsp;&nbsp;{{$t('coverage.title3')}}
      </div>
      <div class="modal-content-mobile">{{$t('coverage.text3')}}</div>
      <div class="modal-title-mobile">
        <Icon type="ios-disc" color="#CF2A2A" />
        &nbsp;&nbsp;{{$t('coverage.title4')}}
      </div>
      <div class="modal-content-mobile">{{$t('coverage.text4')}}</div>
      <div class="modal-title-mobile">
        <Icon type="ios-disc" color="#CF2A2A" />
        &nbsp;&nbsp;{{$t('coverage.title5')}}
      </div>
      <div class="modal-content-mobile">{{$t('coverage.text5')}}</div>
      <div class="modal-title-mobile">
        <Icon type="ios-disc" color="#CF2A2A" />
        &nbsp;&nbsp;{{$t('coverage.title6')}}
      </div>
      <div class="modal-content-mobile">{{$t('coverage.text6')}}</div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'caas-mobile',
  data() {
    return {
      modal: false
    }
  },
  computed: {
    header() {
      return this.$store.state.mImg1
    }
  }
}
</script>
<style lang="less" scoped>
.caas-mobile {
  padding-top: 0.84rem;
  .caas-header {
    background: rgba(249, 249, 249, 1);
    padding: 0.1rem 0 0.3rem 0;
  }
  .caas-introduce {
    padding: 0 0.2rem 0.2rem 0.25rem;
    background: rgba(249, 249, 249, 1);
    .in-box {
      width: 50%;
      float: left;
      padding-left: 0.25rem;
      .in-icon {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 0.2rem;
        .in-img {
          display: flex;
          align-items: center;
          margin-right: 0.1rem;
          img {
            width: 0.17rem;
          }
        }
        .icon-title {
          color: rgba(32, 49, 82, 1);
          font-family: 'Poppins-Light';
          font-size: 0.16rem;
        }
      }
    }
    .in-content {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Light';
      font-size: 0.14rem;
      text-align: left;
      margin: auto;
    }
    .more {
      color: rgba(255, 255, 255, 1);
      background-color: rgba(207, 42, 42, 1);
      border-radius: 4px;
      width: 3.15rem;
      height: 0.34rem;
      line-height: 0.34rem;
      font-family: 'Poppins-Bold';
      font-size: 0.12rem;
      margin: 0.23rem auto 0 auto;
    }
  }
  .caas-network {
    padding: 0.4rem 0.2rem;
    .net-title {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Regular';
      font-size: 0.16rem;
      text-align: left;
    }
    .flex-box {
      .img-box {
        .img-title {
          color: rgba(32, 49, 82, 1);
          font-family: 'Poppins-Light';
          font-size: 0.14rem;
          text-align: left;
          margin: 0.2rem 0;
        }
        .img-content {
          color: rgba(32, 49, 82, 1);
          font-family: 'Poppins-ExtraLight';
          font-size: 0.12rem;
          text-align: left;
          margin-top: 0.2rem;
          span {
            color: rgba(207, 42, 42, 1);
            text-decoration: underline;
          }
        }
      }
    }
  }
  .embed {
    padding: 0.2rem 0.2rem 0.4rem 0.2rem;
    .em-title {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Regular';
      font-size: 0.16rem;
      margin-bottom: 0.1rem;
      text-align: left;
    }
    .flex-box {
      display: flex;
      justify-content: space-around;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0.01rem 0.18rem 0px rgba(0, 0, 0, 0.05);
      border-radius: 0.04rem;
      padding: 0.09rem 0;
      margin: 0.04rem;
      span {
        color: rgba(32, 49, 82, 1);
        font-family: 'Poppins-Regular';
      }
    }
    .content-box {
      margin-top: 0.21rem;
    }
    .con-box {
      .con-title {
        color: rgba(32, 49, 82, 1);
        font-family: 'Poppins-Light';
        font-size: 0.14rem;
        text-align: left;
        margin: 0.2rem 0 0.1rem 0;
      }
      .con-content {
        color: rgba(32, 49, 82, 1);
        font-family: 'Poppins-ExtraLight';
        font-size: 0.12rem;
        text-align: left;
      }
      img {
        margin-bottom: 0.1rem;
      }
    }
  }
  .smart {
    padding: 0.2rem 0.2rem 0.4rem 0.2rem;
    .smart-title {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Regular';
      font-size: 0.16rem;
    }
    .smart-content {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-ExtraLight';
      font-size: 0.12rem;
      text-align: left;
    }
    img {
      margin: 0.1rem 0 0.1rem 0;
    }
  }
}
</style>
<style lang="less">
.modal-title-mobile {
  font-family: 'Poppins-Bold';
  font-size: 0.14rem;
}
.modal-content-mobile {
  font-family: 'Poppins-Light';
  font-size: 0.12rem;
  margin-bottom: 0.1rem;
}
.caas-modal .ivu-modal {
  top: 0 !important;
}
</style>
